import { request } from '@/common/utils/request'
import { getLocation } from '@/common/utils/geo'

export function getLatestPerf(params) {
  // 绩效考核方案指标项下发
  return request
    .get({
      url: 'feidian.perf.getLatestPerf',
      params,
    })
    .then(res => res.data)
}
export function getLatestPerfDetail(params) {
  // 绩效结果-最新绩效详情
  return request
    .get({
      url: 'feidian.perf.getLatestPerfDetail',
      params,
    })
    .then(res => res.data)
}
export function getProjectsCount(params) {
  // 首页-项目总数
  return request
    .get({
      url: 'feidian.bdapp.project.overview',
      params,
    })
    .then(res => res.data)
}

const geo = null

// eslint-disable-next-line no-unused-vars
function getGeo(force = false) {
  // force: 是否强制刷新geo
  return geo
    ? Promise.resolve(geo)
    : // eslint-disable-next-line no-async-promise-executor
      new Promise(async (resolve, reject) => {
        const geo = await getLocation()
        resolve(geo)
      })
}
